import { AUTH_NOMFA } from '../constants';
import { isAdminMfaSessionSatisfied } from './adminMfaSession';
import { isMfaReminderBannerDismissed } from './mfaReminderBanner';

export function isEnforceAdminMfaEnabled() {
  return process.env.REACT_APP_ENFORCE_ADMIN_MFA === 'true';
}

export function isAllowMfaSkipEnabled() {
  return process.env.REACT_APP_ALLOW_MFA_SKIP === 'true';
}

export function isMFAEnabled(preferredMFA) {
  return preferredMFA !== AUTH_NOMFA;
}

export function getPreferredMFA(auth = {}) {
  if (auth.preferredMFA) {
    return auth.preferredMFA;
  }

  const twoFaActive = auth['2faActive'];

  if (!twoFaActive) {
    return AUTH_NOMFA;
  }

  const normalized = String(twoFaActive).toLowerCase();

  if (normalized === 'sms_mfa' || normalized === 'sms') {
    return 'SMS_MFA';
  }

  if (normalized === 'totp') {
    return 'TOTP';
  }

  if (normalized === 'software_token_mfa') {
    return 'SOFTWARE_TOKEN_MFA';
  }

  return AUTH_NOMFA;
}

export function isMfaConfigured(auth = {}) {
  return isMFAEnabled(getPreferredMFA(auth));
}

export function requiresMfaSetup(auth = {}) {
  if (!isEnforceAdminMfaEnabled()) {
    return false;
  }

  if (isAdminMfaSessionSatisfied(auth.username)) {
    return false;
  }

  return !isMfaConfigured(auth);
}

export function shouldShowMfaReminderBanner(auth = {}) {
  if (!isEnforceAdminMfaEnabled()) {
    return false;
  }

  if (isMfaConfigured(auth)) {
    return false;
  }

  return !isMfaReminderBannerDismissed(auth.username);
}

export function getPostAuthRedirectPath(auth = {}) {
  if (!auth.name) {
    return '/extra-info';
  }

  if (requiresMfaSetup(auth)) {
    return '/setup-mfa';
  }

  return '/dashboard';
}
